class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));

    this.getCartData();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;

        this.getCartData();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  async getCartData() {
    let buttons = document.querySelectorAll(".cart__checkout-button");
    let messageElements = document.querySelectorAll(".cart_checkout-message");

    buttons.forEach((button) => (button.style.display = "none"));
    messageElements.forEach(
      (messageElement) => (messageElement.style.display = "none")
    );

    const cartItemsData = [];

    try {
      // Fetch the cart data from the cart_data.liquid template
      const response = await fetch("/pages/cart-data");

      // If the request was not successful, throw an error
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Parse the response text to HTML
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Access the cart items from the parsed HTML
      const cartItems = doc.querySelectorAll(".cart-item-data");

      // Process each cart item
      for (const item of cartItems) {
        // Extract the data from each cart item
        let alcoholVolume = 0;
        const alcoholVolumeAttribute = item.getAttribute("data-alcohol-volume");

        if (alcoholVolumeAttribute) {
          const alcoholVolumeJSON = JSON.parse(alcoholVolumeAttribute);
          alcoholVolume = parseFloat(alcoholVolumeJSON.value);
        }

        const tags = item.getAttribute("data-tags")?.split(", ");
        const price = parseFloat(item.getAttribute("data-price"));
        const quantity = parseInt(item.getAttribute("data-quantity"));

        // Push the data to the cartItemsData array
        cartItemsData.push({
          tags,
          alcoholVolume,
          price,
          quantity,
        });
      }
    } catch (err) {
      // Log any errors to the console
      console.error("Error loading cart data:", err);
    }

    this.checkIfCartIsValid(cartItemsData);
  }

  async checkIfCartIsValid(cartItemsData) {
    var totalAlcoholPrice = 0;
    var totalCartPrice = 0;
    var totalAlcoholVolumeSpirits = 0;
    var totalAlcoholVolumeOthers = 0;

    cartItemsData.forEach(function (item) {
      var alcoholVolume = item.alcoholVolume;
      var price = parseFloat(item.price);
      var quantity = item.quantity;

      totalCartPrice += price * quantity;

      // Check if the product has an alcoholVolume
      if (item.alcoholVolume !== undefined) {
        // Rule 1: Spirits
        if (item.tags.includes("Spirits")) {
          totalAlcoholVolumeSpirits += alcoholVolume * quantity;
          totalAlcoholPrice += price * quantity;
        }

        // Rule 2: Other alcoholic products
        if (item.tags.some((tag) => ["Wine", "Beer", "Ciders"].includes(tag))) {
          totalAlcoholVolumeOthers += alcoholVolume * quantity;
          totalAlcoholPrice += price * quantity;
        }
      }
    });

    console.log("cartItemsData", cartItemsData);
    console.log("totalAlcoholPrice", totalAlcoholPrice);
    console.log("totalCartPrice", totalCartPrice);
    console.log("totalAlcoholVolumeSpirits", totalAlcoholVolumeSpirits);
    console.log("totalAlcoholVolumeOthers", totalAlcoholVolumeOthers);

    let message = "";

    // Check if the rules have been broken
    if (totalAlcoholVolumeSpirits > 2000) {
      message = "The total volume of spirits exceeds the limit of 2000 ml.";
    }

    if (totalAlcoholVolumeOthers > 9000) {
      message =
        "The total volume of wine, beer, liqueur, fortified, and ciders exceeds the limit of 9000 ml.";
    }

    if (totalAlcoholPrice / totalCartPrice > 0.75) {
      message =
        "The total price of alcoholic products exceeds 75% of the total cart value.";
    }

    let buttons = document.querySelectorAll(".cart__checkout-button");
    let messageElements = document.querySelectorAll(".cart_checkout-message");

    if (message === "") {
      // Hide the messages and show the buttons
      messageElements.forEach(
        (messageElement) => (messageElement.style.display = "none")
      );
      buttons.forEach((button) => (button.style.display = "block"));
    } else {
      // Show the messages and hide the buttons
      messageElements.forEach((messageElement) => {
        messageElement.innerText = message;
        messageElement.style.display = "block";
      });
      buttons.forEach((button) => (button.style.display = "none"));
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
        this.getCartData();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });

    
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
